
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const RollingRenewBenchmarkPage = lazy(() => import('./RollingRenewBenchmarkPage'));
const path = 'reports/rolling-renew-benchmark';
const RollingRenewBenchmarkRoute: FuseRouteItemType = {
	path: path,
	element: <RollingRenewBenchmarkPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Rolling Renews Benchmark',
					helpName: 'Rolling Renews Benchmark'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default RollingRenewBenchmarkRoute;
